export default __webpack_public_path__ + "static/article-financial-freedom-9194b72416b5b06905c6f7dd4417060d.jpg";